import * as actionTypes from './actionTypes';

export const toggleNavigationSidebar = () => ({
  type: actionTypes.TOGGLE_NAVIGATION_SIDEBAR,
});

export const handleToggleNavigationSidebar = () => (dispatch, getState) => {
  dispatch(toggleNavigationSidebar());
};
